export enum DueDateCalculationType{
    ByCompletedWork = "By Completed Work",
    ByFrequency = "By Frequency"
}